import { type GQLError } from '@egw/clients'

export interface IGQLErrorResponse {
  response: {
    errors?: BackendError[]
  }
}

export interface BackendError {
  message: string
  locations: string[]
  extensions: {
    evergreenErrorType: string
    errorType: string
    origin: string
  }
}

export enum EBackendError {
  NSF = 'NSF',
  VelocityLimitExceeded = 'VELOCITY_LIMIT_EXCEEDED',
  GENERIC = 'GENERIC',
}

export interface TBackendError {
  backendError: IGQLErrorResponse | BackendError[] | GQLError
}

export enum BankInvestmentTransferValidationError {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  BAD_REQUEST = 'BAD_REQUEST',
  NA = 'NA',
}
